"use strict";

import angular from "angular";

angular.module("nucont.logout", ["nucont.shared"]);
require("./logout.routes");
